import React, { useState, useContext, createContext } from 'react';

type Props = {
  children: React.ReactNode;
};

type LoadingContextData = {
  loading: boolean;
  setLoading: React.Dispatch<React.SetStateAction<boolean>>;
};

const LoadingContext = createContext({} as LoadingContextData);

const LoadingProvider = ({ children }: Props) => {
  const [loading, setLoading] = useState(false);

  return (
    <LoadingContext.Provider value={{ loading, setLoading }}>
      {children}
    </LoadingContext.Provider>
  );
};

export const useLoading = () => {
  const context = useContext(LoadingContext);

  return context;
};

export default LoadingProvider;
